var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    width: 28,
    height: 28
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.566 4.73-1.793-1.218a1.088 1.088 0 0 0-1.507.285l-8.79 12.96-4.039-4.038a1.085 1.085 0 0 0-1.53 0L3.37 14.254a1.09 1.09 0 0 0 0 1.535L9.582 22c.348.348.895.613 1.387.613s.988-.308 1.308-.773L22.855 6.234a1.082 1.082 0 0 0-.289-1.504Z"
  })));
};

export default SvgCheck;